import 'vue/jsx'

// 引入windi css
import '@/plugins/unocss'

// 导入全局的svg图标
// import '@/plugins/svgIcon'

// 初始化多语言
import { setupI18n } from '@/plugins/vueI18n'

// 引入状态管理
import { setupStore } from '@/store'

// 全局组件
import { setupGlobCom } from '@/components'

// 引入element-plus
import { setupElementPlus } from '@/plugins/elementPlus'

// 引入全局样式
import '@/styles/index.less'

// 引入动画
import '@/plugins/animate.css'

// elementPlus图标库
// import * as ElementPlusIconsVue from '@element-plus/icons-vue'
// 引入elementPlus
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'

// 路由
import { setupRouter } from './router'

// 权限
import { setupPermission } from './directives'

import $ from 'jquery'
import { hiPrintPlugin } from 'vue-plugin-hiprint'

import { createApp } from 'vue'

import App from './App.vue'

import './permission'
// 创建实例
const setupAll = async () => {
  const app = createApp(App)

  app.use(ElementPlus)
  // for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  //   app.component(key, component)
  // }

  await setupI18n(app)

  setupStore(app)

  setupGlobCom(app)

  setupElementPlus(app)

  setupRouter(app)

  setupPermission(app)
  app.use($)
  app.mount('#app')
  // 关闭客户端连接
  hiPrintPlugin.disAutoConnect()

  app.use(hiPrintPlugin)
}

setupAll()
